











































































import { Component, Vue, Prop } from 'vue-property-decorator'
import { ExStore } from 'vuex'
import dayjs from 'dayjs'
import { ScheduleState } from '@/store/schedule/types'
import { mbSubstr, mbStrlen } from '@/utils/string'
import { Patient, Worker } from '@/types/user'
import { eventType2Css } from '@/utils/schedule'
import { ScheduleEventType } from '@/constants/schedule'
import { isCordovaEnvironment } from '@/utils/cordova'

export enum EmbeddedResouceTypes {
  DICOM = 'dicom',
  IMAGE = 'image',
  DOCUMENT = 'document'
}

@Component({
  components: {
    UserIcon: () => import('@/components/common/UserIcon.vue'),
    EmbeddedResourceModal: () =>
      import('@/components/comments/EmbeddedResourceModal.vue')
  }
})
export default class Schedule extends Vue {
  @Prop(Object) readonly schedule!: ScheduleState
  @Prop(Object) readonly patient!: Patient

  readonly CONTENT_LIMIT_LENGTH = 400
  $store!: ExStore
  showAllContent = false

  executedButtion = {
    pending: false
  }

  selectedEmbeddedResourceId: number | null = null
  selectedEmbeddedResourceType: EmbeddedResouceTypes | null = null
  showEmbeddedResourceModal = false

  get userInfo() {
    return this.$store.getters['user/userInfo']
  }

  get datetime() {
    const date = dayjs(this.schedule.date).format('M月D日')
    const hour = `0${this.schedule.startHour}`.substr(-2, 2)
    const minute = `0${this.schedule.startMinute}`.substr(-2, 2)
    return `${date} ${hour}:${minute}`
  }

  get worker() {
    return this.$store.getters['worker/workersById']([this.schedule.worker])[0]
  }

  get eventworkers() {
    if (!this.schedule.eventworkerSet) {
      return []
    }

    return this.schedule.eventworkerSet.reduce((eventworkers, { worker }) => {
      const _worker = this.$store.getters['worker/workers'][worker as number]
      return _worker ? eventworkers.concat(_worker) : eventworkers
    }, [] as Array<Worker>)
  }

  get performedDatetime() {
    return dayjs(this.schedule.performedDatetime).format('M月D日 HH:mm')
  }

  get scheduleContent() {
    const text = this.showAllContent
      ? this.schedule.content
      : mbSubstr(this.schedule.content, 0, this.CONTENT_LIMIT_LENGTH)

    const element = document.createElement('div')

    element.innerText = text

    return element.innerHTML.replace(
      /(\[((image|dicom|document):\d+)\])/g,
      '<a href data-embedded-resource="$2">$1</a>'
    )
  }

  get isHideText() {
    return mbStrlen(this.schedule.content) > this.CONTENT_LIMIT_LENGTH
  }

  async handleClickEmbeddedResource(event: Event) {
    if (event.target instanceof HTMLLinkElement !== false) {
      return
    }

    const embeddedToken = (event.target as HTMLLinkElement).getAttribute(
      'data-embedded-resource'
    )

    if (!embeddedToken) {
      return
    }

    event.preventDefault()

    const [type, id] = embeddedToken.split(':') as [
      EmbeddedResouceTypes,
      string
    ]

    if (type === EmbeddedResouceTypes.DOCUMENT) {
      await this.downloadCsv(Number(id))
      return
    }

    this.selectedEmbeddedResourceId = Number(id)
    this.selectedEmbeddedResourceType = type
    this.showEmbeddedResourceModal = true
  }

  get eventTypeCss() {
    return eventType2Css((this.schedule.eventType || '') as ScheduleEventType)
  }

  async downloadCsv(documentId: number) {
    const patientId = this.patient.id

    const [fileInfo, fileSource] = await Promise.all([
      this.$api.document.fetchOne({
        patientId,
        documentId
      }),
      this.$api.document.fetchFile({
        patientId,
        documentId
      })
    ])

    if (isCordovaEnvironment()) {
      this.$postMessage.openFileDownload({
        isPatient: this.userInfo.isPatient,
        isRelative: this.userInfo.isPatientRelative,
        type: 'document',
        patientId: patientId,
        fileId: documentId,
        fileName: fileInfo.fileName || ''
      })
      return
    }

    const url = window.URL.createObjectURL(fileSource)
    const a = document.createElement('a')
    a.style.opacity = '0'
    document.body.appendChild(a)
    a.download = fileInfo.fileName || ''
    a.href = url
    a.click()
    a.remove()
    setTimeout(() => {
      URL.revokeObjectURL(url)
    }, 100)
  }

  handleCloseEmbeddedResourceModal() {
    this.selectedEmbeddedResourceId = null
    this.selectedEmbeddedResourceType = null
    this.showEmbeddedResourceModal = false
  }

  handleClickShowMore() {
    this.showAllContent = true
  }

  handleClickClose() {
    this.showAllContent = false
  }

  handleClickReply() {
    this.$emit('clickReply')
  }

  async handleClickExecuted() {
    try {
      if (this.executedButtion.pending) {
        return
      }

      this.executedButtion.pending = true

      const id = this.schedule.id
      const params = { isPerformed: true }

      await this.$store.dispatch('schedule/update', { id, params })
    } catch (err) {
      // TODO 例外時の処理があればここに記述する
      // console.error(err)
    } finally {
      this.executedButtion.pending = false
    }
  }

  async handleClickDeleteButton(scheduleId: number) {
    this.$emit('delete', scheduleId)
  }
}
